
const { ccclass, property } = cc._decorator;
import ModelBase from "../../../../framework/core/mvvm/model_base"

import * as ProtoPokerRoom from "../../net/proto/proto_poker_room";
import * as ProtoPokerLogin from "../../net/proto/proto_poker_login";
import NetMsgDataBase from "../../net/net_msg_data_table_base";
import TableBaseModel from "../table_base/table_base_model";


@ccclass
export default class PokerTableBaseModel extends TableBaseModel {

}
